import React, { useState, useEffect } from 'react'
import { useField } from 'formik'

const IpsaTextField = ({ label, ...props }) => {
    const [field, meta] = useField(props)
    const [focus, setFocus] = useState(false)
    const [moveLabel, setMoveLabel] = useState(true)

    const { touched, error } = meta

    useEffect(() => {
        const { value } = meta
        setMoveLabel(value || focus)
    }, [focus, meta]) // meta.value ? - gives a warning about meta not in deps list. I think this is fine

    const FocusIn = (event) => {
        event.target.select()
        setFocus(true)
    }
    const FocusOut = (event) => {
        setFocus(false)
        field.onBlur(event)
    }

    const getClassName = () => {
        let rtnClass = moveLabel ? 'move-label' : ''
        if (touched && error) {
            rtnClass = `${rtnClass}  error-field`
        }
        return rtnClass
    }

    return (
        <>
            <input
                {...field}
                {...props}
                className={getClassName()}
                onFocus={FocusIn}
                onBlur={FocusOut}
                autoComplete="off"
            />
            <label className={error && touched ? 'error' : ''}>{label}</label>
            {/* {touched && error ? <div className="error">{error}</div> : null} */}
        </>
    )
}

export default IpsaTextField
